<template>
  <div class="articlemanagement station-page">
    <Row type="flex" justify="center" align="top" class="code-row-bg">
      <!--左侧地图-->
      <Col span="14">
      <Card :style="'margin-right: 5px;height:' + (height + 120) + 'px'">
        <!--地图组件-->
        <component is="leaflet" :areaColor="areaColorList" ref="mapCase" @updateNode="updateNode">
          <div class="leaflet" :style="'height:' + (height + 90) + 'px'">
            <div id="station_map_id" ref="map" class="map"></div>
          </div>
        </component>
      </Card>
      </Col>
      <!--右侧表格-->
      <Col span="10">
      <div class="nodeArea">
        <Card style="position:relative;" :bordered="false">
            <div slot="title" class="title-row">

              <!-- <h3 class="station-name-box">{{ langMap.stationManagement[lang] }}</h3> -->

              <Form class="query-form" :model="queryForm" :label-width="80" :inline="true">
                <FormItem class="query-form-item" :label-width="95" :label="langMap.stationName[lang]" prop="name">
                  <Input v-model="queryForm.name" :placeholder="langMap.pleaseInputStationName[lang]" clearable />
                </FormItem>

                <Button type="primary" style="margin-left:10px;" @click="searchData">{{ langMap.search[lang] }}</Button>
                <Button style="margin-left:10px;" @click="resetForm">{{ langMap.reset[lang] }}</Button>
              </Form>

              <div>
                <Button type="primary" @click="modelShow(true, null)" :disabled="isDrawing">{{ langMap.add[lang] }}</Button>
                <Button v-if="isDrawing" style="margin-left:10px;" @click="cancelDrawing">{{ langMap.cancel[lang] }}</Button>
              </div>
            </div>

          <Table :loading="tableLoading" :height="height" border :columns="col" :data="nodeList" @on-row-click="rowClick">
          </Table>
          <div class="page-box" v-show="queryForm.total>0">
            <Page :current="queryForm.index" :total="queryForm.total" :page-size="15" @on-change="goPageData"></Page>
          </div>
        </Card>

        <Modal :mask-closable="false" v-model="saveModal" :title="opType==='add'?langMap.addNewStation[lang]:langMap.editStation[lang]">
          <div style="max-height: 600px; overflow-y: auto; padding-right: 10px;">
            <Form class="save-form-box" ref="formValidate" :model="saveForm" :rules="ruleValidate" :label-width="labelWidth">
              <FormItem :label="langMap.name[lang]" prop="name">
                <Input v-model="saveForm.name" :placeholder="langMap.pleaseInputName[lang]" clearable />
              </FormItem>
              <FormItem :label="langMap.latLng[lang]" class="leftFlex" prop="lng" v-show="saveForm.name">
                <div>
                  <span v-show="saveForm.lng">{{ saveForm.lng }}，{{ saveForm.lat }}</span>
                  <div v-show="!saveForm.lng">
                    <Button @click="addMarker">{{ langMap.draw[lang] }}</Button>
                    <Button style="margin-left: 10px;" @click="enableImport">
                      {{ langMap.import[lang] }}
                    </Button>
                  </div>
                </div>
              </FormItem>
              <FormItem :label="langMap.importData[lang]" v-if="saveForm.isImported || opType === 'edit'">
                <Input 
                  v-model="saveForm.collectionData" 
                  type="textarea" 
                  :disabled="opType === 'edit' && !saveForm.isImported"
                  :autosize="{ minRows: 4, maxRows: 8 }" 
                  :placeholder="opType === 'edit' && !saveForm.collectionData ? langMap.noImportData[this.lang] : importPlaceholder" 
                />
                <div style="margin-top: 5px;" v-if="saveForm.isImported">
                  <fileSelect @change="fileChange" />
                  <span style="font-size: 12px;color:#87888a;">（{{ langMap.supportFiles[lang] }}）</span>
                </div>
              </FormItem>
              <FormItem :label="langMap.description[lang]">
                <Input v-model="saveForm.description" type="textarea" clearable :autosize="{ minRows: 4, maxRows: 8 }"
                  :placeholder="langMap.descInfo[lang]" />
              </FormItem>
              <DynamicForm
                ref="dynamicForm"
                v-model="saveForm.attrs"
                :configKey="formConfigKey"
              />
            </Form>
          </div>
          <div slot="footer">
            <Button type="text" :loading="btnLoading" @click="saveModal = false">{{ langMap.cancel[lang] }}</Button>
            <Button type="primary" :loading="btnLoading" @click="saveNode">{{ langMap.save[lang] }}</Button>
          </div>
        </Modal>
      </div>
      </Col>
    </Row>
    <Spin fix v-if="pageLoading">
      <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
      <div>{{ langMap.loading[lang] }}</div>
    </Spin>
  </div>
</template>
<script>
import leaflet from './mapUnit/leaflet.vue';
import { readJsonFile } from '@/utils/index.js';
import api from "../../../api";
import langMap from '@/utils/language';
import { mapState } from 'vuex';
import DynamicForm from '@/components/DynamicForm/index.vue'
let mapCase = null;

function initSaveFrom() {
  return {
    id: null,
    name: '',
    lat: null,
    lng: null,
    description: '',
    isImported: false,         // 是否使用导入方式
    collectionData: '',   // 导入的原始JSON
    attrs: null
  }
}

export default {
  name: 'stationManage',
  components: { leaflet, DynamicForm, fileSelect: () => import('@/components/fileSelect/index.vue') },
  data() {
    return {
      langMap:langMap,
      placeSearch: null,
      height: (document.documentElement.clientHeight - 260),
      line: null,
      currentMarker: null,
      markers: [],
      nodeTypeList: [],
      btnLoading: false,
      saveModal: false,
      isDrawing: false, // 是否正在绘制中

      mapLoading: true, // 地图加载状态
      tableLoading: true, // 表格加载状态
      nodeList: [],
      // 新增/编辑 信息
      opType: 'add',
      // 查询时表单
      queryForm: {
        name: '',
        index: 1,
        total: 0, // 所有数据总量
      },
      // 保存时表单
      saveForm: initSaveFrom(),
      showImportInput: false,
      importJsonText: '',
      importPlaceholder: `{
        "lat": 30.262776,
        "lng": 120.123748
}`,
      formConfigKey: 'homeworkNodeMap',
      dynamicFormConfig: []
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
      areaColorList: state => state.app.mapAreaColor
    }),
    pageLoading() {
      return this.mapLoading || this.tableLoading;
    },
    labelWidth() {
      // 默认 80
      let width = 80;
      // 使用 data 中的 dynamicFormConfig 判断，避免依赖 $refs
      if (this.dynamicFormConfig && this.dynamicFormConfig.length > 0) {
        width = 120; // DynamicForm 默认 120
      }
      return width;
    },
    col(){
      return [
        {
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: langMap.name[this.lang],
          key: 'name',
        },
        {
          title: langMap.description[this.lang],
          key: 'description',
          render: (h, { row }) => {
            let text = row.description;
            return h("span", text);
          }
        },
        {
          title: langMap.operation[this.lang],
          align: 'center',
          width: 120,
          render: (h, params) => {
            //渲染数组
            var renderArray = [];
            renderArray.push(
              h('Button', {
                props: {
                  type: 'text',
                  size: 'small'
                },
                style: {
                  padding: "1px",
                  color: "#2d8cf0"
                },
                on: {
                  click: ($e) => {
                    $e.stopPropagation();
                    // params.row
                    this.modelShow(true, params.row);
                  }
                }
              }, langMap.modify[this.lang])
            );
            renderArray.push(
              h('Divider', {
                props: {
                  type: 'vertical',
                },
                style: {
                  margin: "0 2px"
                }
              })
            )
            renderArray.push(
              h('Button', {
                props: {
                  type: 'text',
                  size: 'small'
                },
                style: {
                  padding: "1px",
                  color: "#2d8cf0"
                },
                on: {
                  click: ($e) => {
                    $e.stopPropagation();
                    this.$Modal.confirm({
                      title: langMap.systemTip[this.lang],
                      content: langMap.confirmDeleteStation[this.lang],
                      okText: langMap.confirm[this.lang],
                      cancelText: langMap.cancel[this.lang],
                      onOk: () => {
                        this.delMarker(params.row);
                      }
                    })
                  }
                }
              }, langMap.delete[this.lang])
            );
            return h("div", renderArray);
          }
        }
      ]
    },
    ruleValidate(){
      return {
        name: [
          { required: true, message: langMap.nameRequired[this.lang], trigger: 'blur' }
        ],
        lng: [
          { 
            required: true, 
            validator: (rule, value, callback) => {
              // 如果使用导入方式，验证collectionData字段
              if (this.saveForm.isImported) {
                if (!this.saveForm.collectionData) {
                  callback(new Error(this.langMap.importDataRequired[this.lang]));
                } else {
                  try {
                    JSON.parse(this.saveForm.collectionData);
                    callback();
                  } catch (err) {
                    callback(new Error(this.langMap.jsonFormatError[this.lang]));
                  }
                }
              } else if (!value && value !== 0) {
                // 如果使用绘制方式，验证lng字段
                callback(new Error(this.langMap.latLngRequired[this.lang]));
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ]
      }
    }
  },
  methods: {
    // 分页数据
    goPageData(pageIndex) {
      this.queryForm.index = pageIndex;
      this.loadStations();
    },
    //搜索数据
    searchData() {
      this.queryForm.index = 1;
      this.loadStations();
    },
    //初始化地图
    async initMap() {
      mapCase = this.$refs.mapCase;
      await mapCase.initMap();
      this.$nextTick(() => {
        this.mapLoading = false;
      });
      // 确保先绘制区域
      await this.loadAreas();
      this.loadStations();
    },
    //加载现有区域
    loadAreas() {
      return api.getData("task-server/fence/list", this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          if (res.data && res.data.length > 0) {
            // 区域绘制
            mapCase.initTargetArea(res.data);
            if(res.data[0] && res.data[0].area){
              // 移动数据中心点
              const area1 = JSON.parse(res.data[0].area);
              const _point = area1.length && area1[0];
              mapCase.moveToCenter([parseFloat(_point.lon), parseFloat(_point.lat)]);
            }
          }
        }
      });
    },
    // 加载已有站点数据
    loadStations() {
      this.tableLoading = true;
      const _form = this.queryForm;
      const _str = `name=${_form.name}&index=${_form.index}`;
      api.getData('task-server/robotStation/list?' + _str, this).then((res) => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg,
          });
        } else {
          if (res.data) {
            this.nodeList = res.data.rows || [];
            _form.total = res.data.total;
            //初始化任务节点
            mapCase.initStations(this.nodeList);
          }
        }
      }).finally(() => {
        this.tableLoading = false; 
      })
    },
    // 获取动态表单配置以确定 labelWidth
    async fetchDynamicConfig() {
      try {
        const res = await api.getData(`system-server/config/list?keys=${this.formConfigKey}`);
        if (res.state === 1 && res.data && res.data[this.formConfigKey]) {
          const config = res.data[this.formConfigKey];
          if (config.configValue) {
            this.dynamicFormConfig = JSON.parse(config.configValue) || [];
          }
        }
      } catch (error) {
        console.error('获取动态表单配置失败:', error);
      }
    },
    resetForm() {
      this.queryForm = {
        name: '',
        index: 1,
        total: 0, // 所有数据总量
      }
      this.loadStations();
    },
    rowClick(data) {
      mapCase.createPopup(data.id);
    },
    //点击按钮添标记点，每次追加
    addMarker() {
      // 清空导入相关的字段
      this.saveForm.isImported = false;
      this.saveForm.collectionData = '';

      this.$nextTick(() => {
        this.saveModal = false;
        this.isDrawing = true; // 标记为正在绘制
      });

      const row = { ...this.saveForm };
      mapCase.addMarker(row);
    },
    // 取消绘制
    cancelDrawing() {
      this.isDrawing = false;
      // 清除地图上正在绘制的标记
      if (mapCase && mapCase.cancelDrawing) {
        mapCase.cancelDrawing();
      }
      // 重新打开弹窗
      this.saveModal = true;
    },
    //删除节点
    delMarker(row) {
      //mapCase.delMarker(row);
      api.getData('task-server/robotStation/delete/' + row.id, this).then((res) => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg,
          });

        }else{
          this.$Notice.success({
            title: langMap.deleteSuccess[this.lang],
          });

          this.loadStations();
        }
      });
    },
    // 新增或编辑
    modelShow(flag, data) {
      if (data) {
        this.opType = 'edit';
        this.saveForm = { ...data };
      } else {
        this.opType = 'add';
        this.saveForm = initSaveFrom();
      }
      this.btnLoading = false;
      this.saveModal = flag;
      this.isDrawing = false; // 打开弹窗时重置绘制状态
    },
    //保存节点（新增或编辑）
    async saveNode() {
      const saveForm = this.saveForm;

      this.$refs['formValidate'].validate(async (valid) => {
        if (!valid) return;

        this.btnLoading = true;
        try {
          if (this.$refs.dynamicForm) {
            saveForm.attrs = await this.$refs.dynamicForm.validate();
          }
          // 过滤 attrs 字段
          this.saveAttrsHandle(saveForm);

          // save
          const res = await api.postData("task-server/robotStation/save", saveForm, this);
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: res.msg,
            });
          } else {
            // 非地图要素更新时才请求数据
            if (this.opType !== 'edit:map') this.loadStations();

            this.$nextTick(() => {
              this.saveModal = false;
            });

            this.$Notice.success({
              title: langMap.saveSuccess[this.lang],
            });
          }
        } catch (err) {
          // 处理请求异常或校验异常
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: err.message || langMap.requestFailed[this.lang],
          });
          console.error('保存站点失败:', err);
        } finally {
          // 无论成功还是失败，都重置按钮状态
          this.btnLoading = false;
        }
      });
    },
    /*更新节点并保存
    nodeItem: 一个站点数据
    opType: 操作类型 add/edit
    */
    updateNode(nodeItem, opType) {
      this.opType = opType;
      this.saveForm = nodeItem;
      this.isDrawing = false; // 绘制完成，重置状态
      //this.saveNode(nodeItem);
      //this.saveModal = true;
      this.$nextTick(() => {
        this.saveNode();
      });
    },

    // 选择文件后触发
    fileChange(files) {
      readJsonFile(files[0]).then(res => {
        this.saveForm.collectionData = res;
      });
    },
    
    // 启用导入功能
    enableImport() {
      this.saveForm.isImported = true;
    },

    saveAttrsHandle(item) {
      if (item.attrs) {
        let dynamicFormData = Object.keys(item.attrs).reduce((acc, key) => {
          const value = item.attrs[key];
          if (value != null && value !== "") {
            acc[key] = value + '';
          }
          return acc;
        }, {});
        if (JSON.stringify(dynamicFormData) === '{}') {
          dynamicFormData = null
        }
        item.attrs = dynamicFormData;
      }
    },
  },
  mounted() {
    //初始化地图、初始化地图组件
    this.$nextTick(this.initMap);
    this.fetchDynamicConfig();
  }
}
</script>
<style scoped lang="less">
.station-page{
  position: relative;
}
.station-name-box {
  padding: 10px 0;
}

.query-form-item {
  margin-bottom: 0;
  /deep/.ivu-form-item-label {
    font-size: 14px;
  }
}
.title-row{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.page-box{
  padding-top: 10px;
}

.save-form-box{
  .ivu-form-item{margin-bottom: 18px;}
}
.leaflet {
  width: 100%;
  height: 500px;
  margin-left: 0px;
  position: relative;
}

.nodeArea {
  width: 100%;
  height: 500px;
}

.map {
  width: 100%;
  height: calc(100%);
  z-index: 1;
}

.my-div-icon {
  background-color: transparent;
  border: 0;
}

.input-item {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
  height: 3rem;
}

.input-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border-radius: .25rem;
  width: 22rem;
  border-width: 0;
  border-radius: 0.4rem;
  box-shadow: 0 2px 6px 0 rgba(114, 124, 245, .5);
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 0.75rem 1.25rem;
  font-size: 12px;
}

.custom-input-card {
  width: 18rem;
}

.custom-input-card .btn:last-child {
  margin-left: 1rem;
}

.content-window-card {
  position: relative;
  width: 23rem;
  padding: 0.75rem 0 0 1.25rem;
  box-shadow: none;
  bottom: 0;
  left: 0;
}

.content-window-card p {
  height: 2rem;
}

.des-cardTittle-box {
  display: flex;
  justify-content: space-between;
}

#myPageTop {
  position: absolute;
  top: 5px;
  right: 10px;
  background: #fff none repeat scroll 0 0;
  border: 1px solid #ccc;
  margin: 10px auto;
  padding: 6px;
  font-family: "Microsoft Yahei", "微软雅黑", "Pinghei";
  font-size: 14px;
  z-index: 10;
}

#myPageTop label {
  margin: 0 20px 0 0;
  color: #666666;
  font-weight: normal;
}

#myPageTop input {
  width: 170px;
}

#myPageTop .column2 {
  padding-left: 25px;
}

.demo-spin-icon-load {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
